import {
  APP_SETTING_DEFAULT_PAGE_BEGIN,
  APP_SETTING_DEFAULT_PAGE_SUCCESS,
  APP_SETTING_DEFAULT_PAGE_FAILURE,
  APP_SETTING_DEFAULT_PAGE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import cookie from 'react-cookies';
import { updateUserIpInCookie } from '../../../common/utils/api_utils';


export function changeDefaultPage(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_DEFAULT_PAGE_BEGIN,
    });
    dispatch({
      type: APP_SETTING_DEFAULT_PAGE_BEGIN,
    });
    const { projectId, version, defaultPageUuid } = args;
    const userIp = cookie.load('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, true, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/default-page/${defaultPageUuid}`,
        {},
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_DEFAULT_PAGE_SUCCESS,
            data: res.data,
          });
          toast.success('Default Page Set Successfully !', {});
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_DEFAULT_PAGE_FAILURE,
            data: { error: err },
          });
          toast.error('Updation Failed !', {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissChangeDefaultPageError() {
  return {
    type: APP_SETTING_DEFAULT_PAGE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_DEFAULT_PAGE_BEGIN:
      return {
        ...state,
        changeDefaultPagePending: true,
        changeDefaultPageError: null,
      };

    case APP_SETTING_DEFAULT_PAGE_SUCCESS:
      return {
        ...state,
        changeDefaultPagePending: false,
        changeDefaultPageError: null,
        defaultPage: action.data,
      };

    case APP_SETTING_DEFAULT_PAGE_FAILURE:
      return {
        ...state,
        changeDefaultPagePending: false,
        changeDefaultPageError: action.data.error,
      };

    case APP_SETTING_DEFAULT_PAGE_DISMISS_ERROR:
      return {
        ...state,
        changeDefaultPageError: null,
      };

    default:
      return state;
  }
}
